import { TAlertTypes } from '@r1-frontend/ui-react/components/Alert/TAlertTypes';

import { TInitialState } from '../reducer/initialState';

export type TNotChecked = {
    checked: false,
    alertType: 'info',
    message: null,
};

export type TCheckResult = {
    checked: true,
    alertType: TAlertTypes,
    message: string,
}

const getCheckerResult = (state: TInitialState): TNotChecked | TCheckResult => {
    const { checkResult } = state;

    if (!checkResult) {
        return { checked: false, alertType: 'info', message: null };
    }

    let alertType: TAlertTypes = 'success';

    if (checkResult) {
        const { isConnectionAvailable, isTariffAvailableForActivation } = checkResult;

        if (!isConnectionAvailable) {
            alertType = 'error';
        } else if (!isTariffAvailableForActivation) {
            alertType = 'info';
        }
    }


    return {
        checked: true,
        alertType,
        message: checkResult.message,
    };
};

export default getCheckerResult;
